import * as Const from './Const';
import initialState from './initialState';

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case Const.GET_SAVED_POLICIES_SUCCESS: {
      return Object.assign({}, state, {
        savedPolicies: action.results
      });
    }
    case Const.GET_SAVED_SEARCHES_SUCCESS: {
      return Object.assign({}, state, {
        savedSearches: action.results
      });
    }
    // case Const.GET_FAVORITE_SEARCHES_SUCCESS:
    // case Const.ADD_TO_FAVORITE_SEARCH_SUCCESS:
    // case Const.REMOVE_FROM_FAVORITE_SEARCH_SUCCESS:
    //     {
    //         return Object.assign({}, state, {
    //             favoriteSearches:
    //             action.results
    //         });
    //     }
    default:
      return state;
  }
}
